import React from 'react';

import Segment from '../../../../components/Segment';
import Card from '../Card';
import WistiaHOC from './WistiaHOC';

import './style.scss';

const segment = new Segment();

class CardAdvisor extends React.Component {
  componentDidMount() {
    const { advisor } = this.props;
    segment.trackLink(this.linkedInLink, 'step5_clicked_linkedinprofile', {
      id: advisor.id,
      email: advisor.email,
      first_name: advisor.first_name,
      last_name: advisor.last_name,
    });
  }

  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  getWistia() {
    if (!this.props.wistiaId) {
      return null;
    }
    const Wistia = WistiaHOC(this.props.wistiaId, this.props.advisor);
    return (
      <div className="card-advisor__media">
        <div className="card-advisor__aspect">
          <Wistia />
        </div>
      </div>
    );
  }

  getImage() {
    if (!this.props.image || this.props.wistiaId) {
      return null;
    }
    return (
      <div className="card-advisor__media">
        <div className="card-advisor__aspect">
          <div className="card-advisor__image">
            <div>{this.props.image}</div>
          </div>
        </div>
      </div>
    );
  }

  getExpertiseItem = (item, idx) => {
    return (
      <div key={`${item}-${idx}`} className="card-advisor__expertise--item">
        {item}
      </div>
    );
  };

  getExpertise() {
    if (!this.props.expertise || !this.props.expertise.length) {
      return null;
    }

    const firstName = this.props.name.split(' ')[0];

    return (
      <div className="card-advisor__expertise">
        <div className="card-advisor__expertise--heading">
          {firstName} is an expert in
        </div>
        {this.props.expertise.map(this.getExpertiseItem)}
      </div>
    );
  }

  render() {
    const firstName = this.props.name.split(' ')[0];

    return (
      <Card>
        <div className="card-advisor__wrapper">
          {this.getWistia()}
          {this.getImage()}
          <div className="card-advisor__name">{this.props.name}</div>
          <div className="card-advisor__position">{this.props.position}</div>
          <div className="card-advisor__company">{this.props.company}</div>
          <hr />
          <div className="card-advisor__education">
            {this.props.degree && <div>{this.props.degree}</div>}
            {this.props.university && <div>{this.props.university}</div>}
          </div>
          {this.getExpertise()}
          <div className="card-advisor__learnmore">
            <a
              ref={ref => {
                this.linkedInLink = ref;
              }}
              href={`https://linkedin.com/in/${this.props.linkedinUsername}`}
              target="_blank"
            >
              View LinkedIn Profile
            </a>
          </div>
          <div className="card-advisor__connect">
            <button
              type="button"
              className="btn btn-paragon-one"
              onClick={this.handleClick}
            >
              Request {firstName}
            </button>
          </div>
        </div>
      </Card>
    );
  }
}

export default CardAdvisor;



// WEBPACK FOOTER //
// ./src/routes/assessment/components/CardAdvisor/index.js